<div class="d-flex justify-content-center align-items-center pt-5">
  <span class="alert alert-success d-flex justify-content-center align-items-center grid-gap-05rem">
    <fa-icon icon="check"></fa-icon>
    <div>Santé : OK</div>
  </span>
</div>
